import { EventTarget, Event } from 'event-target-shim';

export class AbortError extends Error {
  name = 'AbortError';
  message = 'Aborted';
}

export class AbortSignal extends EventTarget {
  aborted = false;
}

export class AbortController {
  signal = new AbortSignal();

  abort = () => {
    const abortEvent = new Event('abort');

    this.signal.dispatchEvent(abortEvent);
    this.signal.aborted = true;
  };
}
